export default __webpack_public_path__ + "static/doggos-7ec54d4e0d3803c1d5904f6980076152.png";